import { Component, OnInit } from '@angular/core';
import { animate, transition, trigger, state, style } from '@angular/animations';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { NextValutationDate } from 'src/app/models/NextValutationDate';
import { DialogService } from 'src/app/core/services/dialog.service';
import { AuthService } from 'src/app/core/services/user-services/auth.service';
import { Helpers } from 'src/app/models/Helpers/helpers';
import { DataStatus } from 'src/app/models/Helpers/data-status';
import { Loader } from 'src/app/models/Helpers/loader';
import { NextValutationDateService } from 'src/app/core/services/tables/next-valutation-date.service';
import { TableObject } from 'src/app/models/tableObject';
import {AddToWatchlistManagerService} from '../../../core/services/watchlists/add-to-watchlist-manager.service';

@Component({
  selector: 'app-next-valutation-date-table',
  templateUrl: './next-valutation-date-table.component.html',
  styleUrls: ['./next-valutation-date-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class NextValutationDateTableComponent implements OnInit {

  userIsGuest: boolean;
  tableInfoExists: boolean;
  state = 'collapsed';

  TABLE_TITLE = 'Prossime Date di Osservazione';
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['Isin', 'Isin'],
    ['Nome', 'Nome'],
    ['Sottostante', 'Sottostante'],
    ['Data', 'Data'],
    ['Prezzosott', 'Prezzo Sott.'],
    ['Trigger', 'Trigger'],
    ['Prezzocert', 'Prezzo Cert.'],
    ['Datrigger', 'MoT'],
    ['Upside', 'Upside']
  ];

  records: NextValutationDate[];
  tableDataStatus = new DataStatus();
  loader = new Loader();

  sortingFilter: string;
  sortingAscending: boolean;

  constructor(
    private service: NextValutationDateService,
    private infoService: InfoService,
    private userService: AuthService,
    public dialogService: DialogService,
    private addToWatchlistManager: AddToWatchlistManagerService
  ) {
    this.checkIfUserIsGuest()
      .then(userHasGuestRole => {
        this.userIsGuest = userHasGuestRole;
      });
  }

  ngOnInit(): void {
    this.tableInfoExists = this.infoService.isThereInfo(this.TABLE_TITLE);
  }

  private async checkIfUserIsGuest() {
    const user = await this.userService.userManager.getUser();
    return user?.profile?.role === 'CedLabGuest';
  }

  public toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';

    if (this.state === 'expanded') {
      if (this.userIsGuest) {
        this.getNextValutationDateRecordsGuest();
      } else {
        this.getNextValutationDateRecords();
      }
    }
  }

  public triggerSorting({ active, direction }) {

    if (this.userIsGuest) { return; }

    this.sortingFilter = active;
    switch (direction) {
      case 'asc':
        this.sortingAscending = true;
        break;
      case 'desc':
        this.sortingAscending = false;
        break;
      default: this.sortingAscending = null;
    }

    this.getNextValutationDateRecords();
  }


  private getNextValutationDateRecords() {
    this.tableDataStatus.resetStatus();
    this.loader.show();

    this.service.get(1, 10, this.sortingFilter, this.sortingAscending)
      .subscribe(
        (resultSet: TableObject<NextValutationDate>) => {
          this.loader.hide();
          if (resultSet.totalRecords > 0) {
            this.records = resultSet.records;
            this.tableDataStatus.setStatus('success');
          } else {
            this.tableDataStatus
              .setStatus('info')
              .setAlertMessage('Nessun isin presente')
              .setAlertClasses(['cedlab-info']);
          }
        },
        error => {
          console.log('ERROR IN HOME -> PROX. DATE DI OSS. -> GET', error);

          this.loader.hide();
          this.tableDataStatus
            .setStatus('failure')
            .setAlertMessage('Errore nel caricamento dei dati')
            .setAlertClasses(['cedlab-danger']);
        });
  }

  private getNextValutationDateRecordsGuest() {
    this.tableDataStatus.resetStatus();
    this.loader.show();
    this.service.getForGuest(1, 10, this.sortingFilter, this.sortingAscending)
      .subscribe(
        (resultSet: TableObject<NextValutationDate>) => {
          this.loader.hide();
          if (resultSet.totalRecords > 0) {
            this.records = resultSet.records;
            this.tableDataStatus.setStatus('success');
          } else {
            this.tableDataStatus
              .setStatus('info')
              .setAlertMessage('Nessun isin presente')
              .setAlertClasses(['cedlab-info']);
          }
        },

        error => {
          console.log('ERROR IN HOME -> PROX. DATE DI OSS. -> GET FOR GUEST', error);

          this.loader.hide();
          this.tableDataStatus
            .setStatus('failure')
            .setAlertMessage('Errore nel caricamento dei dati')
            .setAlertClasses(['cedlab-danger']);
        });
  }

  public addIsinToWatchlist(isin: string) {
    if (this.userIsGuest) {
      this.dialogService.openFailureSnackBar('Abbonati ai servizi CedLab per usufruire dell\'esperienza completa');
      return;
    }

    this.addToWatchlistManager.addToWatchlist(isin);
  }

  public localeCurrency = (currency: string) => Helpers.getCurrencyLocale(currency);
  public currencySymbol = (currency: string) => Helpers.getCurrencySymbol(currency);
  public openInfoDialog() {
    const tableInfo = this.infoService.getTableInfo(this.TABLE_TITLE);
    this.dialogService.openTableInfoDialog(tableInfo);
  }
}
